import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map } from 'rxjs';
import { PushNotificationChannel, PushNotificationChannelsKeys } from '@ag-common-lib/lib';
import { NotificationChannelsService } from 'ag-common-svc/lib/components/administration/notifications-hub/notifications-channels/notifications-channels.service';

@Pipe({
  name: 'notificationsChannelById',
})
export class NorificationChannelByIdPipe implements PipeTransform {
  constructor(private notificationChannelsService: NotificationChannelsService) {}

  transform(channelDbId: string): Observable<string[]> {
    return this.notificationChannelsService.channelsMap$.pipe(
      map(channelsMap => {
        let selectedNotificationsChannelsName: string[] = [];
        const _getChannels = channelDbId => channelsMap.get(channelDbId);

        const addParentChannel = (channel: PushNotificationChannel) => {
          const parentChannelDbId = channel?.[PushNotificationChannelsKeys.parentChannelDbId];
          const channelName = channel?.[PushNotificationChannelsKeys.name];

          if (!parentChannelDbId) {
            selectedNotificationsChannelsName.push(channelName);
            return;
          }
          selectedNotificationsChannelsName.push(channelName);

          const parentChannel = _getChannels(parentChannelDbId);
          addParentChannel(parentChannel);
        };

        const channel = _getChannels(channelDbId);
        addParentChannel(channel);

        return selectedNotificationsChannelsName.reverse(); // child as last item
      }),
    );
  }
}
